import { OneTimePaymentActions } from '../../state/payment/actions';

export type ConfirmPaymentOk = {
  ok: true;
  type: 'payment';
  intentId: string;
  status: string;
  paymentMethodId?: string;
  amount?: number;
  currency?: string;
};

export type ConfirmSetupOk = {
  ok: true;
  type: 'setup';
  intentId: string;
  status: string;
  paymentMethodId?: string;
};

export type OneTimeConfirmSucceeded = ReturnType<
  typeof OneTimePaymentActions.confirmSucceeded
>;

export function isOkSetupActionOneTime(
  a: OneTimeConfirmSucceeded
): a is OneTimeConfirmSucceeded & { result: ConfirmSetupOk } {
  return a.result?.ok === true && a.result?.type === 'setup';
}

export type ConfirmError = { ok: false; error: unknown, message: string };

export type ConfirmResult = ConfirmPaymentOk | ConfirmSetupOk | ConfirmError;

export interface PaymentElementFeatureState {
  oneTime: PaymentState;
  recurring: PaymentState;
}

export interface PaymentState {
  containerId: string | null;
  clientSecret: string | null;
  active: boolean;

  elementStatus: 'idle' | 'mounting' | 'mounted' | 'error';
  confirmStatus: 'idle' | 'pending' | 'succeeded' | 'failed';

  mountedFor: string | null;
  lastError: unknown | null;

  lastResult?: {
    type: 'payment' | 'setup';
    intentId: string;
    status: string;
    paymentMethodId?: string;
  };
}
